
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppSelect, AppCard, AppButton } from '@/components';
import { useProgressLevelTranslate } from '@/modules/progress/level/model/translate';
import { ROUTE_NAME_PROGRESS } from '@/modules/progress/router';

export default defineComponent({
    name: ROUTE_NAME_PROGRESS.LEVEL.TRANSLATE,
    components: { AppFormRow, AppInput, AppSelect, AppCard, AppButton },
    setup() {
        const { model, v$, fetch, beforeFetch, actions, localeSupportedOptions } = useProgressLevelTranslate();

        onMounted(async () => {
            await beforeFetch();
            await fetch();
        });

        return { v$, model, fetch, actions, localeSupportedOptions };
    }
});
